import Input from 'portaltransparencia-common/components/EloInput.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';

import FilterButtons from '../components/FilterButtons.react';

export default class ConselhosFiltro extends Component {
  static propTypes = {
    show: PropTypes.bool,
    findConselhos: PropTypes.func.isRequired,
    filterConselhos: PropTypes.func.isRequired,
    resetConselhos: PropTypes.func.isRequired
  };

  filtro = React.createRef();

  onPesquisa = () => {
    const { filterConselhos, resetConselhos } = this.props;

    resetConselhos();

    const valueFiltro = this.filtro.current?.getValue();
    if (valueFiltro) {
      filterConselhos(valueFiltro);
    }
  };

  onResetFiltro = () => {
    const { resetConselhos } = this.props;
    resetConselhos();
  };

  handleKeyDown = event => {
    const teclaEnter = 13;
    if (event.keyCode === teclaEnter) {
      this.onPesquisa();
    }
  };

  render() {
    const { show } = this.props;

    if (!show) {
      return null;
    }

    return (
      <Panel title="Consultar em Conselhos" mobileClose isForm>
        <Row>
          <Col xs={12} sm={4} md={8}>
            <Input
              id="conselho"
              name="conselho"
              ref={this.filtro}
              label="Conselho"
              placeholder="Pesquisar Conselhos"
              onKeyDown={this.handleKeyDown}
              type="text"
            />
          </Col>
          <Col xs={12} sm={4} md={4}>
            <FilterButtons
              idBtnReset="btnResetFilter"
              onConsulta={this.onPesquisa}
              onReset={this.onResetFiltro}
            />
          </Col>
        </Row>
      </Panel>
    );
  }
}
